import React, { useCallback } from 'react'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import LoadingIndicator from '@/components/LoadingIndicator'
import { FormLoader } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { useDataLoader } from '@/hooks/useDataLoader'
import { BlacklistDetailForm } from '@/internal-app/pages/blackLists/detail'

export const BlacklistDetailDialog = React.memo(function BlacklistDetailDialog (props) {
  const { isOriginal, loadData, value } = props
  const dataSource = useCallback(() => loadData(value.id), [loadData, value.id])
  const { data, loading } = useDataLoader(dataSource)
  return (
    <ValidationBoundary>
      <BasicHeader title='Blacklists.BlacklistDetailTitle' {...props} />
      {!isOriginal
        ? <BlacklistDetailFormWrapper {...props} />
        : loading ? <ModalBody><LoadingIndicator /></ModalBody> : <BlacklistDetailFormWrapper {...props} id={data.id} value={data} />
      }
    </ValidationBoundary>
  )
})

function BlacklistDetailFormWrapper (props) {
  return (
    <FormLoader {...props} render={({ targetId }) => <DetailForm {...props} targetId={targetId} />} />
  )
}

const DetailForm = React.memo(function DetailForm (props) {
  const { targetId } = props
  return (
    <React.Fragment>
      <ModalBody>
        <BlacklistDetailForm targetId={targetId} readonly />
      </ModalBody>
      <ChangeItemDialogFooter {...props} readonly />
    </React.Fragment>
  )
})

export default {
  modalProps: {
    size: 'lg'
  },
  component: BlacklistDetailDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/blacklistDetail.js